import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { User } from '../types/user.type';
import { AdminUpdateUserRequestDTO } from '../types/dtos/admin-update-user.dto';
import { ADMIN_USERS_API_PATHS } from '../constants/users-paths.constants';

type UseAdminUpdateUserResult = {
  isSubmitting: boolean;
  updateUser: (userId: string, payload: AdminUpdateUserRequestDTO) => Promise<User | null>;
};

export function useAdminUpdateUser(): UseAdminUpdateUserResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateUser = async (userId: string, payload: AdminUpdateUserRequestDTO): Promise<User | null> => {
    setIsSubmitting(true);

    try {
      const updatedUser = await HttpClient.patch<User, AdminUpdateUserRequestDTO>(
        ADMIN_USERS_API_PATHS.UPDATE_USER(userId),
        payload
      );

      enqueueSnackbar('Utilisateur mis à jour avec succès', { variant: 'success' });
      return updatedUser;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de la mise à jour de l'utilisateur"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, updateUser };
}
